import React from 'react';
import useValuePerYearTotalChart from './hooks/useValuePerYearTotalChart';
import { SimpleBars } from '../../../Common/Charts/SimpleBars';

export const ValuePerYearTotal = ({ height }) => {
    const { series, subtitles } = useValuePerYearTotalChart();

    return (
        <SimpleBars
            height={height}
            series={series}
            values={[]}
            subtitles={subtitles}
            isMoney
            title={`Soma do Valor por Ano`}
        />
    );
};
